import { useEffect, useState } from 'react';
import type { HuddleBreakout } from '@avslack/shared';

/**
 * A kiscsoportos idoszak VEGE a SAJAT ora szerint - es a helyi lejarat
 * (docs/19-kiscsoportos-szobak.html).
 *
 * A lejaratot a kliens maga is figyeli: a szerver lezaro munkasa csak a
 * biztosito. Az `endsAt` abszolut idopont, a pillanatkep kesziteseko
 * szerver-idohoz (`serverNow`) igazitva - igy egy rosszul allitott gep sem
 * szamol vissza rosszul, es a visszateres akkor is azonnali, ha a lezaro
 * esemeny kesik vagy elveszik.
 *
 * Visszaadja a NYITOTT idoszakot (a helyi ora szerint mar lejartat nem), es a
 * lejaratot a helyi orara szamolva (ms). Ha a hazigazda hosszabbit, az `endsAt`
 * valtozik, es az idoszak ujra nyitott lesz - a lejart-jelolo az (azonosito, vege)
 * paros, nem csak az azonosito.
 */
export function useBreakoutClock(raw: HuddleBreakout | null): {
  breakout: HuddleBreakout | null;
  endsAtMs: number | null;
} {
  const id = raw?.id ?? null;
  const endsAt = raw?.endsAt ?? null;
  const serverNow = raw?.serverNow ?? null;

  const [endsAtMs, setEndsAtMs] = useState<number | null>(null);
  /** Az a (azonosito|lejarat) par, amit a helyi ora mar lejartnak latott. */
  const [expired, setExpired] = useState<string | null>(null);

  useEffect(() => {
    if (!id || !endsAt || !serverNow) {
      setEndsAtMs(null);
      return;
    }
    const localEnd = Date.parse(endsAt) - (Date.parse(serverNow) - Date.now());
    setEndsAtMs(localEnd);

    const key = `${id}|${endsAt}`;
    const wait = localEnd - Date.now();
    if (wait <= 0) {
      setExpired(key);
      return;
    }
    const timer = window.setTimeout(() => setExpired(key), wait);
    return () => window.clearTimeout(timer);
  }, [id, endsAt, serverNow]);

  const open = raw && expired !== `${raw.id}|${raw.endsAt}` ? raw : null;
  return { breakout: open, endsAtMs };
}
